import React, { useEffect } from 'react'

function Maintenance() {
  //get value of search stored
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <div>
        <div className="main-wrapper landingpage">
          <section
            className="hero-banner home center-bg"
            style={{ minHeight: '100vh', backgroundPositionX: '100%' }}
          >
            <div className="container">
              <div className="row" style={{ paddingTop: '100px' }}>
                <div className="col-sm-7">
                  <div className="banner-content_">
                    <h3
                      // className="mt-5"
                      style={{ color: '#352E49', marginTop: 200 }}
                    >
                      Sorry for the delay - But we are building a better
                      road.Construction will be from Midnight to 6 AM.{' '}
                    </h3>
                  </div>
                </div>

                <div className="col-sm-5">
                  <div
                    id="carouselExampleControls"
                    className="carousel slide mt-5 mb-5"
                    data-ride="carousel"
                  >
                    <div className="carousel-inner">
                      <div className="carousel-item active">
                        <img
                          className="d-block w-100"
                          src="images/maintenance.png"
                          alt="Second slide"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  )
}

export default Maintenance
